module.exports = __webpack_public_path__ + "static/media/path.174589dd.jpg";